import {TicketStatusASM} from "./TicketStatusASM";

export const TicketStatusASMColorMapping = new Map<TicketStatusASM, string>([
  [TicketStatusASM.IN_PROGRESS, "yellow"],
  [TicketStatusASM.ACTIVE, "green"],
  [TicketStatusASM.INACTIVE, "red"]
]);

export function getTicketStatusColor(status: TicketStatusASM | undefined): string {
  if(status) {
    return 'var(--traffic-light-' + TicketStatusASMColorMapping.get(status) + ', $traffic-light-' + TicketStatusASMColorMapping.get(status) + ')';
  }
  else {
    return 'var(--traffic-light-' + "off" + ', $traffic-light-' + "off" + ')';
  }
}
